import { ON_NAV_TOGGLE } from '../state-constants/stateConstants';

export const onNavToggle = (bool) => ({
  type: ON_NAV_TOGGLE,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/onNavToggle.js